export const wizardDetails = {
    AUTOMATEDILCDC: {
        name: "AUTOMATED",
        className: "automated",
        variant: "intresting",
        typographyColor: "primary.500"
    },
    IL_SCHEMACONVERSION: {
        name: "INITIAL LOAD (AUTO-SCHEMA CONVERSION)",
        className: "schemaConversion",
        variant: "default",
        typographyColor: "greyscale.700"
    },
    AUTOMATEDMODE: {
        name: "AUTOMATED MODE",
        className: "automated",
        variant: "intresting",
        typographyColor: "primary.500"
    }
};
